const is_null = (check) => {
  if (check !== "" && check !== undefined && check !== null) return false;
  else return true;
};
export default is_null;
